import React, {useCallback,} from 'react'
import {DefaultLayout, NullAsDefault, TemplateTypes, WidgetPositions, withComp,} from 'views/Shared'
import {TemplateWrapper} from './TemplateWrapper'

const PageTemplate = ({
  children,
  Sider = NullAsDefault,
  LeftSider = null,
  Banner = NullAsDefault,
  Wrapper = TemplateWrapper,
  ...props
}) => {
  const renderContent = useCallback(
    () => children,
    [children]
  )
  const renderContentWithBanner = useCallback(
    () => (
      <>
        <Banner />
        {children}
      </>
    ),
    [children, Banner]
  )
  const sider = withComp(Sider)

  if (LeftSider) {
    const leftSider = withComp(LeftSider)
    return (
      <Wrapper>
        <DefaultLayout
          siders={{
            [WidgetPositions.LEFT]: leftSider,
            [WidgetPositions.RIGHT]: sider,
          }}
          Content={renderContentWithBanner}
          isContentFirst={false}
          type={TemplateTypes.BOTH_SIDER}
          {...props}
          leftSiderWidth={280}
          rightSiderWidth={350}
          noTopSpacing={true}
          wideMaxWidth={true}
        />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Banner />
      <DefaultLayout
        sider={sider}
        Content={renderContent}
        isContentFirst={false}
        type={TemplateTypes.RIGHT_SIDER}
        {...props}
      />
    </Wrapper>
  )
}

export default PageTemplate
